"use strict";

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Chrome_1 = __importDefault(require("../Systems/Chrome"));

var Wrapper_1 = __importDefault(require("./Wrapper"));

var ChromeDownload = function ChromeDownload(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? "auto" : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? "100%" : _ref$width;
  return react_1["default"].createElement(Wrapper_1["default"], {
    height: height,
    width: width
  }, react_1["default"].createElement(Chrome_1["default"], {
    size: 48
  }), react_1["default"].createElement("span", null, "Add to Chrome"));
};

exports["default"] = ChromeDownload;